import { Column } from '../../../../model/table';
import { ApplicationField, LogsDto, TimestampField } from '../../../../dtos/logs.dto';
import { IpWithTooltipCell, TooltipCell } from './special-cells';

export const urlFilteringColumns: Column<LogsDto>[] = [
    {
        accessor: TimestampField,
        header: TimestampField,
        width: 200,
    },
    {
        accessor: 'Category',
        header: 'Category',
        width: 200,
        getDisplayElement: TooltipCell
    },
    {
        accessor: 'URL',
        header: 'URL',
        width: 300,
        getDisplayElement: TooltipCell
    },
    {
        accessor: 'Direction',
        header: 'Direction',
        width: 110,
    },
    {
        accessor: 'Source IP',
        header: 'Source IP',
        width: 350,
        getDisplayElement: IpWithTooltipCell
    },
    {
        accessor: 'Source Country',
        header: 'Source Country',
        width: 200,
    },
    {
        accessor: 'Destination IP',
        header: 'Destination IP',
        width: 350,
        getDisplayElement: IpWithTooltipCell
    },
    {
        accessor: 'Destination Country',
        header: 'Destination Country',
        width: 200,
    },
    {
        accessor: ApplicationField,
        header: ApplicationField,
        width: 350,
        getDisplayElement: TooltipCell
    },
    {
        accessor: 'Child App',
        header: 'Child App',
        width: 200,
    },
    {
        accessor: 'Rule',
        header: 'Rule',
        width: 250,
    },
    {
        accessor: 'Action',
        header: 'Action',
        width: 100,
    }
];
